/**
 * Espelho das chaves de permissão do backend (`Authorization/Permissions.cs`).
 *
 * ⚠ Este arquivo NÃO é a fonte da verdade — o backend é, e é ele quem nega de fato. O que está
 * aqui decide apenas o que o portal DESENHA. Um erro para menos esconde um menu; um erro para mais
 * mostra uma tela que devolve 403. Nenhum dos dois abre acesso.
 *
 * Por que espelhar em vez de baixar o catálogo: as chaves aparecem em `routes.tsx` e nos gates,
 * que são avaliados na primeira renderização — antes de qualquer resposta da API. Constante é o
 * único jeito de o TypeScript pegar o typo em tempo de build.
 *
 * Ao adicionar uma permissão no backend, adicione aqui SÓ se o front for gatear por ela.
 */
export const Permissions = {
  DashboardView: "dashboard.view",

  CapacityView: "capacity.view",
  CapacityManage: "capacity.manage",
  CapacityScheduleTeam: "capacity.schedule.team",

  TasksView: "tasks.view",
  TasksManage: "tasks.manage",
  TasksDelete: "tasks.delete",
  BoardColumnsView: "boardcolumns.view",
  BoardColumnsManage: "boardcolumns.manage",

  TimesheetView: "timesheet.view",
  TimesheetManage: "timesheet.manage",
  TimesheetViewTeam: "timesheet.view.team",

  ClientsView: "clients.view",
  ClientsManage: "clients.manage",
  ProjectsView: "projects.view",
  ProjectsManage: "projects.manage",
  ClientProjectsManage: "clientprojects.manage",
  TeamView: "team.view",

  FinancialView: "financial.view",
  FinancialAdmin: "financial.admin",
  GoalsView: "goals.view",
  GoalsManage: "goals.manage",

  EmployeesViewSelf: "employees.view.self",
  EmployeesView: "employees.view",
  EmployeesManage: "employees.manage",
  OrgView: "org.view",
  OrgManage: "org.manage",
  OrgManageAll: "org.manage.all",

  EquipmentView: "equipment.view",
  EquipmentManage: "equipment.manage",
  EquipmentHistoryView: "equipmenthistory.view",

  ReportsView: "reports.view",
  ReportsWeeklyManager: "reports.weekly.manager",

  DataScopeAll: "data.scope.all",
  DataScopeClients: "data.scope.clients",

  ClientPortalView: "clientportal.view",
  PortalTickets: "portal.tickets",
  PortalProjects: "portal.projects",
  PortalHours: "portal.hours",
  PortalFinancial: "portal.financial",

  ItsmFilaAtender: "itsm.fila.atender",
  ItsmFilaCoordenar: "itsm.fila.coordenar",

  ClienteEquipeGerir: "cliente.equipe.gerir",

  CopilotUse: "copilot.use",
  CopilotAdmin: "copilot.admin",

  NewsView: "news.view",
  NewsManage: "news.manage",

  TicketsView: "tickets.view",
  TicketsManage: "tickets.manage",
  TicketsAdmin: "tickets.admin",

  IntegrationView: "integration.view",
  IntegrationManage: "integration.manage",
  JiraSync: "jira.sync",
  WallpaperView: "wallpaper.view",
  WallpaperManage: "wallpaper.manage",
  ProfilesManage: "profiles.manage",
  DesignSystemView: "designsystem.view",
  UsersRegister: "users.register",
  IdentidadeAdmin: "identidade.admin",
  OrgPeopleManage: "org.people.manage",

  BiView: "bi.view",
  BiTenantManage: "bi.tenant.manage",
  BiMaster: "bi.master",
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];
